import gql from 'graphql-tag';
import commonFragments from '../../../apollo/fragments/common.fragments';
const {StayCollectedFeeQuote, Quote} = commonFragments;

const paymentContainerFragments = {
    CheckoutExperienceModel: gql`
        fragment PaymentContainerCheckoutExperienceModel on CheckoutExperienceModel {
            ...StayCollectedFeeQuoteCheckoutExperienceModel
            ...QuoteCheckoutExperienceModel
            deviceFingerprintUrl
            paymentGatewayType
            countrySettings {
                countryCode
                nationalIdInfo
                nationalIdLabel
                nationalIdRequired
                nationalIdSupported
                nationalIdTitle
                nationalIdTooltipRequired
                passportEnabled
                postalCodeRequired
                vatIdSupported
                stateLabel
            }
        }
        ${StayCollectedFeeQuote.CheckoutExperienceModel}
        ${Quote.CheckoutExperienceModel}
    `,
};

export default paymentContainerFragments;
